import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {TabLimpiezaModel} from '../../../../../models'
import {
  ERROR_MESSAGE_SYSTEM,
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
} from '../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../util/functions'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'
import {cleaningScheduleSchema} from '../../../schema/cleaningSchedule'
import {
  CleaningScheduleBodyDto,
  CleaningScheduleBodyModel,
} from '../../../model/cleaningSchedule.model'
import {CLEANING_SCHEDULE_SERVICES} from '../../../services/cleaning-schedule.service'
import { funcDelete } from '../../../util/function'

const CleaningSchedulePageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLimpieza()
  const [loading, setLoading] = useState(false)
  const methods = useForm<CleaningScheduleBodyModel>({
    resolver: yupResolver(cleaningScheduleSchema),

    defaultValues: {
      days: [false, false, false, false, false, false, false],
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
      Nomenclatura: '',
      TipoEdificacionId: '',
      EsPeriodico: true,
    },
  })

  const handleDelete = async () => {
    await funcDelete(
      CLEANING_SCHEDULE_SERVICES.deleteCleaningSchedule,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: CleaningScheduleBodyModel) => {
    try {
      setLoading(true)
      let body = {}
      if (data.EsPeriodico) {
        const dias = ['LU', 'MA', 'MI', 'JU', 'VI', 'SA', 'DO']
        const strDays = data.days
          ?.map((item, index) => (item ? dias[index] : ''))
          .filter((item) => item !== '')
          .join('-')
        body = {
          CampamentoId: data.CampamentoId,
          TipoEdificacionId: data.TipoEdificacionId,
          Nomenclatura: data.Nomenclatura,
          EsPeriodico: data.EsPeriodico,
          FechaInicio: data.FechaInicio,
          HoraInicio: data.HoraInicio,
          TipoRepeticion: data.TipoRepeticion,
          FechaFin: data.FechaFin,
          CantidadRepeticion: data.CantidadRepeticion,
          DiasSeleccionado: strDays, // "LU-MA-MI-JU-VI-SA"
        } as CleaningScheduleBodyDto
      } else {
        body = {
          CampamentoId: data.CampamentoId,
          TipoEdificacionId: data.TipoEdificacionId,
          Nomenclatura: data.Nomenclatura,
          EsPeriodico: data.EsPeriodico,
        } as CleaningScheduleBodyDto
      }
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await CLEANING_SCHEDULE_SERVICES.createCleaningSchedule(body as any)
        : await CLEANING_SCHEDULE_SERVICES.editCleaningSchedule({
            ...body,
            Id: currentTabItem.idToEdit,
          } as any)
      if (!response.data.error) {
        methods.reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        if (isCreating) {
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            showPanel: true,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-cleaning-schedule',
              detailPanel: 'tab-cleaning-schedule',
            },
            idToEdit: response.data.data,
            loadingTable: true,
            currentExternalTab: 1,
          }
          changeCurrentTabItem(obj)
          ShowSnackBar(messageResponse)
        } else {
          const obj: TabLimpiezaModel = {
            ...currentTabItem,
            showPanel: false,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-cleaning-schedule',
            },
            idToEdit: '',
            loadingTable: true,
          }
          changeCurrentTabItem(obj)
          ShowSnackBar(messageResponse)
        }
      } else {
        ShowSnackBar(response.data.message ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
      setLoading(false)
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-cleaning-schedule'
          textComponentGo='form-cleaning-schedule'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-limpieza-header-${currentTabItem.id}`}
              id={`panel-limpieza-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-limpieza-detail-${currentTabItem.id}`}
                    id={`panel-limpieza-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default CleaningSchedulePageWrapper
